import { createSlice } from '@reduxjs/toolkit';

const subjectNames = createSlice({
  name: 'subjectNames',
  initialState: {
    subjectNamesArr: '',
  },
  reducers: {
    setSubjectNames(state, action) {
      state.subjectNamesArr = action.payload;
    },
  },
});

export const { setSubjectNames } = subjectNames.actions;

export const getSubjectNames = state => state.subjectNames.subjectNamesArr;

export default subjectNames.reducer;
